import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import useConfiguration from '../../hooks/useConfiguration';
import useSessionStorage from '../../hooks/useSessionStorage';
import Footer from '../common/Footer';
import Header from '../common/Header';
import Loader from '../common/Loader';
import Error from '../common/Message/error';
import Success from '../common/Message/success';
import DeleteUserModal from '../common/Modal/deleteUserModal';
import UserLocationModal from '../common/Modal/UserLocationModal';
import Sidebar from '../common/Sidebar';
import Spinner from '../common/Spinner/spinner';
import Table from '../common/Table';
import {
  deleteEmployerUser,
  getLocationDropdownList,
  getUserList,
  getUserMappedLocation,
  getUserTypes,
  saveUserMappedLocation
} from './action';
import { usersSelector } from './selector';
import { setInitalState } from './slice';
import './user.css';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem('login');
  const navigate = useNavigate();
  const {
    userList,
    locationDropdownList,
    userTypes,
    successMessage,
    errorMessage,
    loader,
    userMappedLocation,
    loadingFlag
  } = useSelector(usersSelector);
  const [usersList, setUsersList] = useState([]);
  const [locationsDropdownList, setLocationDropdownList] = useState([]);
  const [userTypesList, setUserTypesList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [userType, setUserType] = useState('');
  const [locationName, setLocationName] = useState(0);
  const [approvalUser, setApprovalUser] = useState(false);
  const [formMessage, setFormMessage] = useState('');
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [clear, setClear] = useState(false);
  const [userInfo, setUserInfo] = useState({
    page: 0,
    pageSize: 0,
    sortOrder: 'string',
    sortColumn: 'string',
    locationId: 0,
    employerId: login.employerId,
    employerUniqueId: login.employerUniqueId,
    searchText: 0,
    userType: 0,
    approvalUsers: false,
  });
  const showSearch = true;
  const dispatch = useDispatch();
  const [locationModal, setLocationModal] = useState(false);
  const [locationEmployerUserId, setLocationEmployerUserId] = useState("");

  //   console.log(userInfo);

  useEffect(() => {
    document.title = 'Employers Section';
    dispatch(setInitalState());
  }, []);

  useEffect(() => {
    if (config.baseUrl) {
      setFormMessage('');
      dispatch(getUserList(config.baseUrl, userInfo));
      dispatch(getLocationDropdownList(config.baseUrl, login.employerId));
      dispatch(getUserTypes(config.baseUrl));
    }
  }, [config]);

  useEffect(() => {
    setUsersList(userList);
  }, [userList]);

  useEffect(() => {
    if (locationDropdownList.length > 0) {
      setLocationDropdownList(locationDropdownList);
    }
  }, [locationDropdownList]);

  useEffect(() => {
    if (userTypes.length > 0) {
      setUserTypesList(userTypes);
    }
  }, [userTypes]);

  useEffect(() => {
    if (usersList.length > 0) {
      setFilterList(usersList);
    } else {
      setFilterList([]);
    }
  }, [usersList]);

  useEffect(() => {
    if (successMessage !== null && successMessage === 'Deleted') {
      setFormMessage('Employer User details deleted successfully!');
      dispatch(getUserList(config.baseUrl, userInfo));
    }
  }, [successMessage]);

  useEffect(() => {
    if (errorMessage !== null) setFormMessage(errorMessage);
  }, [errorMessage]);

  const editUser = (row) => {
    navigate('/adduser', {
      state: {
        editUser: true,
        name: row.locationName,
        userDetails: row,
      },
    });
  };

  const setUserFilter = (key, value) => {
    if (key === 'userType') {
      value = Number(value);
    }
    setUserInfo({
      ...userInfo,
      [key]: value,
    });
    setClear(false);
  };

  useEffect(() => {
    if (clear) dispatch(getUserList(config.baseUrl, userInfo));
  }, [userInfo]);

  const getFilterUser = (e) => {
    e.preventDefault();
    dispatch(getUserList(config.baseUrl, userInfo));
  };

  const clearFilter = (e) => {
    e.preventDefault();
    setUserInfo({
      page: 0,
      pageSize: 0,
      sortOrder: 'string',
      sortColumn: 'string',
      locationId: 0,
      employerId: login.employerId,
      employerUniqueId: login.employerUniqueId,
      searchText: 0,
      userType: 0,
      approvalUsers: false,
    });
    //dispatch(getUserList(config.baseUrl,userInfo))
    setClear(true);
  };

  const showDeleteModal = (row) => {
    setShowDelete(true);
    setDeleteId(row.employerUserId);
  };

  const handleDeleteClose = () => setShowDelete(false);

  const handleDelete = () => {
    dispatch(deleteEmployerUser(config.baseUrl, deleteId, login.appUserId));
    setShowDelete(false);
  };

  useEffect(() => {
    //console.log("Test by ram ",locationEmployerUserId)
    if (config.baseUrl)
      if (locationEmployerUserId !== "") {
        dispatch(getUserMappedLocation(config.baseUrl, locationEmployerUserId));
        return () => { };
      }
  }, [config.baseUrl, locationEmployerUserId]);

  const showLocationModal = (row) => {
    setLocationEmployerUserId(row.employerUserId);
    setLocationModal(!locationModal);
  };

  const handleLocationClose = () => setLocationModal(!locationModal);

  const handleLocation = (data) => {
    const locationList = data.map((element) => element.id);
    const requestJson = {
      employerUserId: locationEmployerUserId,
      locatoinList: locationList,
    };
    //
    dispatch(saveUserMappedLocation(config.baseUrl, requestJson)).then(() => {
      setLocationModal(!locationModal);
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        width: 250,
      },
      {
        Header: 'User Type',
        accessor: 'userTypeDisplayName',
      },
      {
        Header: 'Location Name',
        accessor: 'locationName',
        width: 200,
      },
      {
        Header: 'Cell Phone #',
        accessor: 'cellPhoneNumber',
        width: 200,
      },
      {
        Header: 'Work Phone #',
        accessor: 'workNumber',
        width: 200,
      },
      {
        Header: 'Email Address',
        accessor: 'email',
        width: 200,
      },
      {
        Header: 'Approval',
        accessor: 'isApprovalUser',
        width: 100,
        Cell: ({ row }) => {
          return row.original.isApprovalUser === true ? 'Yes' : 'No'
      }
      },
      {
        Header: 'Contact',
        accessor: 'isContact',
        width: 100,
        Cell: ({ row }) => {
          return row.original.isContact === true ? 'Yes' : 'No'
      }
      }
    ],
    []
  );

  return (
    <div className="page main-margin">
      {/* <Loader /> */}
      {loadingFlag > 0 && <Spinner />}
      <Header />
      <Sidebar />
      <div className="page-main">
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <h1 className="page-title">Users</h1>

                {/* <div>
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <a href="javascript:void(0)">Dashboard</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Users
                    </li>
                  </ol>
                </div> */}
              </div>
              <div className="row">
                <div class="col-xl-12">
                  <div class="card">
                    <div class="col-lg-12 col-md-12">
                      {/* <div class="row">
                        <div class="card-header cardheader">
                          <h4>Users Filter</h4>
                        </div>
                      </div> */}
                    </div>
                    <div class="card-body" id="userForm">
                    <Form autoComplete="off" noValidate className="border-bottom pb-2">
                        <Row>
                          <Form.Group
                            as={Col}
                            className="mb-2 md-4"
                            controlId="userType"
                          >
                            <Form.Label>User Type</Form.Label>
                            <Form.Select
                              value={userInfo.userType}
                              onChange={(e) => {
                                setUserFilter(
                                  'userType',
                                  e.currentTarget.value
                                );
                              }}
                            >
                              <option value="">--Select--</option>
                              {userTypesList.map((area, n) => (
                                <option key={`userType${n}`} value={area.id}>
                                  {area.name}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            className="md-4"
                            controlId="location"
                          >
                            <Form.Label>Location name</Form.Label>
                            <Form.Select
                              onChange={(e) => {
                                setUserFilter(
                                  'locationId',
                                  e.currentTarget.value
                                );
                              }}
                              value={userInfo.locationId}
                            >
                              <option value="0">--Select--</option>
                              {locationsDropdownList.map((area, n) => (
                                <option
                                  key={`traveldistance_${n}`}
                                  value={area.id}
                                >
                                  {area.name}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            className="my-auto pt-2"
                            controlId="checkContact"
                          >
                            <Form.Label></Form.Label>
                            {/* <Form.Check
                              type="checkbox"
                              label="Approval Users"
                              checked={userInfo.approvalUsers}
                              onChange={(e) => {
                                setUserFilter(
                                  'approvalUsers',
                                  e.currentTarget.checked
                                );
                              }}
                            /> */}
                          </Form.Group>

                          <div
                            class="btn-toolbar col-md-2 sw-toolbar sw-toolbar-bottom align-items-center justify-content-end"
                          >
                            <div
                              class="btn-group pe-2 sw-btn-group"
                              role="group"
                            >
                              <button
                                class="btn btn-primary sw-btn-next"
                                type="button"
                                onClick={(e) => getFilterUser(e)}
                              >
                                Filter
                              </button>
                            </div>
                            <div
                              class="btn-group sw-btn-group-extra"
                              role="group"
                            >
                              <button
                                class="btn btn-outline-primary"
                                type="button"
                                onClick={(e) => clearFilter(e)}
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </Row>
                      
                      </Form>
                    
                      <div class="row pt-3 ">
                        <div class="table">
                          {errorMessage && <Error errorMessage={formMessage} />}
                          {successMessage && (
                            <Success successMessage={formMessage} />
                          )}
                          {
                            loader && filterList.length === 0 ? (<div class="errorMessage">Loading...</div>) :
                              !loader && filterList.length === 0 ? (<div class="errorMessage">No Records Found</div>)
                                : ('')
                          }
                          <Table
                            columns={columns}
                            data={filterList}
                            showSearch={showSearch}
                            edit={editUser}
                            showDeleteModal={showDeleteModal}
                            showLocationModal={showLocationModal}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Delete Modal Component */}
            <DeleteUserModal
              showDelete={showDelete}
              handleDeleteClose={handleDeleteClose}
              handleDelete={handleDelete}
            />

            {!!userMappedLocation &&
              userMappedLocation.employerUserId === locationEmployerUserId && (
                <UserLocationModal
                  locationModal={locationModal}
                  handleLocationClose={handleLocationClose}
                  handleLocation={handleLocation}
                  data={userMappedLocation}
                />
              )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
